import { OnInit, Injectable } from '@angular/core';

import { StageService } from '../../../../services/stage.service';
import { Object3DcloneService } from '../../../../services/object3-dclone.service';
import { RoomStateManagerService } from '../../../../services/room-state-manager.service';
import { Model3DService } from '../../../../services/model3-d.service';
// import {WallHolesService} from '../../../services/wall/wall-holes.service';
import { ObjectCheckerService } from '../../../../services/object-checker.service';
import { CloneLocatorService } from '../../../../service/clone-locator.service';
import { IHandler } from './IHandler';
import { Select3dService } from '../../../../services/select-3d.service';

declare const THREE: any;

@Injectable()
export class CloneHandler implements IHandler {
  name: string;

  constructor(
    protected cloneLocatorService: CloneLocatorService,
    protected object3DCloneSrvc: Object3DcloneService,
    protected model3D: Model3DService,
    protected StageSrvc: StageService,
    // protected wallHoles: WallHolesService,
    protected objectCheckerSrvc: ObjectCheckerService,
    protected roomStateManager: RoomStateManagerService,
    private Select3D: Select3dService
  ) {
    this.name = 'clone';
  }

  invoke(selected) {
    const clonePosition = this.cloneLocatorService.calculatePosition(selected);

    if (clonePosition) {
      const clone = this.object3DCloneSrvc.clone(selected);
      const entity = selected.userData.entity;
      const wallName = selected.userData.wall;
      const casing = entity.casing;

      this.model3D
        .create(entity, {
          casing: casing,
          object3D: clone.mesh,
          position: clonePosition,
          rotation: clone.rotation,
          wall: wallName,
          name: selected.name
        })
        .then(obj => {
          this.StageSrvc.add(obj);
          THREE.SceneUtils.attach(obj, this.StageSrvc.getScene(), selected.parent);

          // this.wallHoles.update(wallName);
        });
    }

    return false;
  }

  canExecute(objects) {
    const onlyOneSelected = objects.length === 1;

    if (!onlyOneSelected) {
      return false;
    }

    const mesh = objects[0];

    const isValidObjectType =
      !this.objectCheckerSrvc.isWall(mesh) &&
      !this.objectCheckerSrvc.isFloor(mesh) &&
      !this.objectCheckerSrvc.isWallEmbeddable(mesh) &&
      !this.objectCheckerSrvc.isAwning(mesh);

    return isValidObjectType;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectControls/Handlers/CloneHandler.ts